import api from '../services/api';
import { getSiteId } from '../siteId/siteId';

const SITES_V2_SETTINGS_URL = '/sites/v2/settings';

const siteSettingsService = {
    getSettings,
};

export default siteSettingsService;

function getSettings () {
    const requestConfig = {
        url: SITES_V2_SETTINGS_URL,
        method: 'GET',
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}
